import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { AppShellComponent } from './core/components/app-shell/app-shell.component';

const routes: Routes = [
  // {
  //   path: 'authentication',
  //   loadChildren: () => import('./modules/authentication/authentication.module')
  //     .then(m => m.AuthenticationModule)
  // },
  {
    path: '',
    component: AppShellComponent,
    children: [
      {
        path: '',
        redirectTo: '/home/homepage',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule)
      },
      {
        path: 'management',
        loadChildren: () => import('./modules/management/management.module').then((m) => m.ManagementModule)
      },
      {
        path: 'authentication',
        loadChildren: () => import('./modules/authentication/authentication.module').then((m) => m.AuthenticationModule)
      },
      {
        path: 'management',
        loadChildren: () => import('./modules/management/management.module').then((m) => m.ManagementModule)
      },
      {
        path: 'clients',
        loadChildren: () => import('./modules/clients/clients.module').then((m) => m.ClientsModule)
      },
      {
        path: '**',
        redirectTo: '/home/homepage',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: NoPreloading,
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
